export default __webpack_public_path__ + "static/media/veg.2120c80f.svg";